export default __webpack_public_path__ + "static/featured-image-ff36eb2f89736c1b9040cf7bd81abfc3.png";